export default __webpack_public_path__ + "static/media/nhl-live.1d88d747.jpg";